import { Injectable } from '@angular/core';
import { createTRPCProxyClient } from '@trpc/client';
import { environment } from '../../../environments/environment';
import { ChargeIntent } from '../../models';
import { getTRPCClientOptions } from '../../utils/trpc.utils';
import { SessionsService } from '../sessions/sessions.service';
import { ChargeIntentsService } from './charge-intents.service';

@Injectable()
export class ChargeIntentsServiceApi implements ChargeIntentsService {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private client: any;

  constructor(
    private sessionsService: SessionsService,
  ) {
    this.client = createTRPCProxyClient(getTRPCClientOptions(`${environment.apiUrl}/myChargeIntents`, () => this.sessionsService.getAccessToken()));
  }

  get(id: string): Promise<ChargeIntent | null> {
    return this.client.get.query({ id }).then(({ data }: { data: ChargeIntent | null; }) => data);
  }
}
